import { FC, ReactNode } from 'react';
import { trackSocial } from 'dibs-tracking';

export type Props = {
    href: string;
    trackingLabel?: string;
    serverRenderedChildren: ReactNode;
};

const SocialLinkRowItemTracking: FC<Props> = ({ trackingLabel, href, serverRenderedChildren }) => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    <span
        onClick={() => {
            trackSocial({
                name: trackingLabel,
                socialAction: 'fan page',
                opt_target: href,
                opt_pagePath: href,
            });
        }}
    >
        {serverRenderedChildren}
    </span>
);

export default SocialLinkRowItemTracking;
